import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import reactStringReplace from 'react-string-replace';
import * as Icons from 'react-feather';
import AddProductDetailTabType from './AddProductDetailTabType';
import EditProductDetailTabType from './EditProductDetailTabType';
import ViewProductDetailTabType from './ViewProductDetailTabType';
import DeleteProductDetailTabType from './DeleteProductDetailTabType';
import ProductDetailTabTypeModel from './models/ProductDetailTabTypeModel';
import { logAuditEvent } from '../../../utils/auditLogger';

function ProductDetailTabTypeModal({
  onClose,
  onSubmit,
  UserAction,
  show,
  selectedRow,
  moduleName = 'Product Detail Tab Types',
}) {
  const [childData, setChildData] = useState(new ProductDetailTabTypeModel());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userAction = reactStringReplace(UserAction, 'User', () => '');

  useEffect(() => {
    if (show && selectedRow) {
      setChildData({ ...selectedRow });
    } else if (!show) {
      setChildData(new ProductDetailTabTypeModel());
    }
  }, [selectedRow, show]);

  const handleDataFromChild = (data) => setChildData(data);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const actionDescriptor = UserAction === 'Delete' ? 'Delete Confirm' : 'Save';
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`);
    try {
      await onSubmit(e, childData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = (label) => {
    logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`);
    onClose();
  };

  const handleLoad = (data) => setChildData(data);

  let modalAction = null;
  let showButtons = null;

  if (UserAction === 'Add') {
    modalAction = <AddProductDetailTabType onLoad={handleLoad} sendDataToParent={handleDataFromChild} />;
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')} disabled={isSubmitting}>
          Cancel
        </button>
        <button className="btn btn-submit" name="Add" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    );
  } else if (UserAction === 'Edit') {
    modalAction = <EditProductDetailTabType TabTypeData={childData} sendDataToParent={handleDataFromChild} />;
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')} disabled={isSubmitting}>
          Cancel
        </button>
        <button className="btn btn-submit" name="Edit" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    );
  } else if (UserAction === 'View') {
    modalAction = <ViewProductDetailTabType TabTypeData={selectedRow} />;
    showButtons = (
      <button className="btn btn-cancel me-2" name="View" onClick={() => handleCancel('Close')}>
        Close
      </button>
    );
  } else if (UserAction === 'Delete') {
    modalAction = <DeleteProductDetailTabType TabTypeData={selectedRow} />;
    showButtons = (
      <div>
        <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')}>
          Cancel
        </button>
        <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit} disabled={isSubmitting}>
          Delete
        </button>
      </div>
    );
  }

  if (UserAction === 'Delete') {
    return (
      <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
        <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
          <ModalTitle>
            <div className="custom-alert-icon">
              <Icons.AlertOctagon className="flex-shrink-0" />
            </div>
            <div>{userAction} Product Detail Tab Type</div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>{modalAction}</ModalBody>
        <ModalFooter className="modalfooter-width">{showButtons}</ModalFooter>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
      <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
        <ModalTitle>{userAction} Product Detail Tab Type</ModalTitle>
      </ModalHeader>
      <ModalBody>{modalAction}</ModalBody>
      <ModalFooter>{showButtons}</ModalFooter>
    </Modal>
  );
}

export default ProductDetailTabTypeModal;
